import axios from "../libs/axios/axios-cases";
import type {
  DeleteFunction,
  QueryFunction,
  QueryResult,
  ReadFunction,
  ReadResult,
  UpdateFunction,
  UpdateResult,
} from "../types/API";
import { ClientData } from "../types/documents";
import type { CaseData } from "../types/documents/Case";

const searchClients: QueryFunction<ClientData> = async (body, signal?) => {
  const { data } = await axios.post<QueryResult<ClientData>>(
    "/list-clients",
    body,
    {
      signal,
    }
  );
  return data;
};

const query: QueryFunction<CaseData> = async (body, signal?) => {
  const { data } = await axios.post<QueryResult<CaseData>>(
    "/list-cases",
    body,
    {
      signal,
    }
  );
  return data;
};

const read: ReadFunction<CaseData> = async (id, childId = "", signal?) => {
  const path = `/${id}/${childId}`;
  const { data } = await axios.get<ReadResult<CaseData>>(path, { signal });
  return data;
};

const update: UpdateFunction<CaseData> = async (body) => {
  const { data } = await axios.put<UpdateResult>("/submit", body);
  return data;
};

const deleteFn: DeleteFunction = async (id, childId) => {
  await axios.delete(`/${id}/${childId}`);
};

export const api = {
  query,
  read,
  update,
  create: update,
  delete: deleteFn,
  searchClients,
};
